/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { useState } from "react";
import { useTranslation } from "react-i18next";
import NavbarDesktop from "./NavbarDesktop";
import NavbarMobile from "./NavbarMobile";
import HeroSection from "./HeroSection";
import { COLORS } from "./hero.constants";

export default function NavbarHero() {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
  const [isOpen, setIsOpen] = useState(false);

  const toggleLang = () => {
    i18n.changeLanguage(isArabic ? "en" : "ar");
    document.body.dir = isArabic ? "ltr" : "rtl";
  };

  return (
    <div style={{ fontFamily: "'Tajawal', 'Cairo', sans-serif" }}>
      <nav
        className="navbar shadow-sm"
        style={{
          background: COLORS.gradient,
          padding: "12px 0",
          color: COLORS.textLight,
        }}
      >
        <NavbarDesktop
          isArabic={isArabic}
          onToggleLang={toggleLang}
          onToggleMenu={() => setIsOpen(!isOpen)}
        />
      </nav>

      {isOpen && (
        <NavbarMobile
          isArabic={isArabic}
          onToggleLang={toggleLang}
          onClose={() => setIsOpen(false)}
        />
      )}

      <HeroSection isArabic={isArabic} />
    </div>
  );
}
